import React from "react";
import { withStyles } from "@mui/styles";

import FormHeader from "../../../components/formHeader/FormHeader";
import FormDescription from "../../../components/formDescription/FormDescription";
import Button from "../../../components/button/Button";

const styles = (theme) => ({
  section: {
    width: "100%",
    backgroundColor: "#fff",
  },
  textSection: {
    marginBottom: 20,
  },
  paymentOption: {
    border: "1px solid #e0e0e0",
    borderRadius: 8,
    padding: 20,
    marginBottom: 16,
  },
  paymentOptionTitle: {
    fontSize: 18,
    fontWeight: 600,
    marginBottom: 8,
  },
  paymentOptionDescription: {
    color: "#666",
    fontSize: 14,
    marginBottom: 12,
    lineHeight: "1.5",
  },
  skipButton: {
    marginTop: 40,
    textAlign: "center",
  },
  skipLink: {
    color: "#999",
    fontSize: 13,
    cursor: "pointer",
    textDecoration: "underline",
    "&:hover": {
      color: "#666",
    },
  },
});

function SetupGoCardlessForm({
  classes,
  goCardlessUrl,
  stripeUrl,
  onSubmit,
  onSkip,
  submitting,
  isSetup,
}) {
  // Setup flow: show both payment options + skip
  if (onSkip) {
    return (
      <div className={classes.section}>
        <div className={classes.setupInformation}>
          <FormHeader title="Setup Payments" />
          <FormDescription>
            <div className={classes.textSection}>
              Choose a payment provider to collect payments from your players.
              You can always change this later in club settings.
            </div>
          </FormDescription>

          <div className={classes.paymentOption}>
            <div className={classes.paymentOptionTitle}>GoCardless</div>
            <div className={classes.paymentOptionDescription}>
              Collect payments via Direct Debit. Lower fees, ideal for recurring
              payments. Players set up a mandate once, then payments are collected
              automatically.
            </div>
            <a href={goCardlessUrl}>
              <Button title="Setup GoCardless" />
            </a>
          </div>

          <div className={classes.paymentOption}>
            <div className={classes.paymentOptionTitle}>Stripe</div>
            <div className={classes.paymentOptionDescription}>
              Accept card payments, Apple Pay and Google Pay. Quick and easy for
              players to pay. Ideal for one-off payments.
            </div>
            <a href={stripeUrl}>
              <Button title="Setup Stripe" />
            </a>
          </div>

          <div className={classes.skipButton}>
            <span className={classes.skipLink} onClick={onSkip}>
              Skip for now — I'll set up payments later
            </span>
          </div>
        </div>
      </div>
    );
  }

  // Club Settings: show GoCardless only
  return (
    <div className={classes.section}>
      <div className={classes.setupInformation}>
        {isSetup ? (
          <>
            <FormDescription>
              <div className={classes.textSection}>
                <strong>✅ GoCardless is connected</strong>
                <div style={{ marginTop: 10 }}>
                  Your club can now collect payments via Direct Debit.
                </div>
              </div>
            </FormDescription>
          </>
        ) : (
          <>
            <FormDescription>
              <div className={classes.textSection}>
                <div style={{ marginBottom: 10 }}>
                  In order to receive payments from players via Direct Debit, you
                  need to sign up with our payment partner GoCardless.
                </div>
              </div>
            </FormDescription>

            <a href={goCardlessUrl}>
              <Button title="Setup GoCardless" />
            </a>
          </>
        )}
      </div>
    </div>
  );
}

export default withStyles(styles)(SetupGoCardlessForm);
